// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-K":"K_power-ocean-home-K__EkwAP"};